// extracted by mini-css-extract-plugin
export var infoSection = "_9g-1";
export var infoSectionContainer = "_9g-0";
export var infoSectionTitleRow = "_9g-2";
export var multiLineInfo = "_9g-4";
export var strong = "_9g-3";